<template>
    <div class="question-detail-container">
        <div class="chat-container">
            <VoiceSvg ref="voiceSvg" :maxDuration="maxDuration"></VoiceSvg>
            <div class="message-list-wrapper" ref="wrapper">
                <div class="message-list">
                    <van-cell-group class="question-desc-box">
                        <van-cell
                            :title="item.title"
                            v-for="item in startQ"
                            :key="item.name"
                        >
                            <template v-if="item.type.includes('upload')">
                                <img
                                    class="upload-img"
                                    :src="img"
                                    v-for="img in item.value.split(',')"
                                    :key="img"
                                    @click="uploadImgPreivew(img)"
                                />
                            </template>
                            <div class="value" v-else>{{ item.label }}</div>
                        </van-cell>
                    </van-cell-group>
                    <div
                        v-for="(message, index) in replys"
                        :key="message.genId || message.id"
                    >
                        <div class="chat-time" v-if="message.formatTime">
                            {{ message.formatTime }}
                        </div>
                        <div
                            class="message-list-item"
                            :class="{
                                right: isAStaff
                                    ? message.operator.type !== 'User'
                                    : message.operator.type === 'User'
                            }"
                        >
                            <img
                                class="head"
                                :src="message.content.detail.headImg"
                                v-if="message.content.detail.headImg"
                            />
                            <van-icon
                                class="default-head"
                                name="user-o"
                                v-else
                            ></van-icon>
                            <div class="text-box">
                                <van-loading
                                    class="loading-icon"
                                    type="spinner"
                                    v-if="message.loading"
                                    size="12"
                                    style="margin-right: 6px"
                                ></van-loading>
                                <div class="content-box">
                                    <div class="name">
                                        {{ getStaffName(message) }}
                                    </div>
                                    <div class="text">
                                        <img
                                            :src="message.content.content"
                                            v-if="
                                                message.content.detail &&
                                                    message.content.detail
                                                        .msgType === 'image'
                                            "
                                            @click="
                                                imgPreview(
                                                    message.content.content
                                                )
                                            "
                                        />
                                        <div
                                            class="voice"
                                            v-else-if="
                                                message.content.detail &&
                                                    message.content.detail
                                                        .msgType === 'voice'
                                            "
                                            @click="playVoice(message, index)"
                                        >
                                            <div class="icon-wrapper">
                                                <van-loading
                                                    type="spinner"
                                                    size="13"
                                                    v-if="
                                                        voiceDic[message.id] &&
                                                            voiceDic[message.id]
                                                                .loading
                                                    "
                                                ></van-loading>
                                                <VoiceIconSvg
                                                    class="svg"
                                                    :ref="'voiceIcon_' + index"
                                                    v-else
                                                ></VoiceIconSvg>
                                            </div>
                                            <div
                                                class="duration"
                                                v-if="
                                                    message.content.detail
                                                        .duration
                                                "
                                            >
                                                {{
                                                    Math.round(
                                                        message.content.detail
                                                            .duration / 1000
                                                    )
                                                }}''
                                            </div>
                                        </div>
                                        <div
                                            class="say"
                                            v-else
                                            v-html="message.content.content"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chat-input" :class="{ disabled: endOrRealEnd }">
                <div class="icon-box">
                    <img
                        class="icon"
                        v-show="showVoiceIcon"
                        src="@/assets/imgs/v2w.png"
                        @click="switchIconStatus"
                    />
                    <img
                        class="icon"
                        @click="switchIconStatus"
                        v-show="!showVoiceIcon"
                        src="@/assets/imgs/keyboard.png"
                    />
                </div>
                <div class="end-bar" v-if="endOrRealEnd">
                    会话已结束，无法回复
                </div>
                <van-field
                    class="chat-input-box"
                    v-else
                    v-show="showVoiceIcon"
                    placeholder="请输入您要咨询的问题"
                    size="small"
                    v-model="inputVal"
                    @keyup.13="sendMessage()"
                    @focus="onFocus"
                    @blur="onBlur"
                    @confirm="sendMessage()"
                    ref="chatBox"
                ></van-field>
                <div
                    class="chat-input-press-bar"
                    :class="{ pressed, disabled: !hasRecordAccess }"
                    v-show="!showVoiceIcon"
                    @touchstart="touchstart"
                    @touchend="onPressup"
                    @end="onPressup"
                >
                    {{
                        !hasRecordAccess
                            ? '未开启录音授权'
                            : pressed
                            ? '松开 结束'
                            : '按住 说话'
                    }}
                </div>
                <van-uploader
                    class="photo-wrapper"
                    :after-read="upload"
                    max-count="1"
                >
                    <div class="photo">
                        <van-icon name="photo-o"></van-icon>
                    </div>
                </van-uploader>
                <div class="send-button" @click="sendMessage()">发送</div>
            </div>
            <div
                class="back-to-bottom"
                @click="scrollToBottom(0)"
                v-show="showBackToBotton"
            >
                回到最新位置
            </div>
            <van-popup
                class="comment-modal"
                v-model="isShowCommentModal"
                round="round"
            >
                <div class="question">会话结束，请对此次服务进行评价？</div>
                <div class="button-group">
                    <div
                        class="button"
                        @click="comment(item)"
                        v-for="item in commentActions"
                        :key="item.id"
                    >
                        {{ item.remark }}
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import {
    GetTicketDetail,
    Reply,
    GetUploadSignature,
    Upload,
    GetAvailableStatus,
    GetAvailableAuditor,
    PutTransition,
    GetNewLogs
} from '@/service/ticket'
import { mapState, mapActions } from 'vuex'
import { genId, sleep } from '@/utils/common'
import { saveMedia } from '@/service/record'
import dayjs from 'dayjs'
import VoiceIconSvg from '@/views/components/VoiceIconSvg'
import VoiceSvg from '@/views/components/VoiceSvg'
import BScroll from '@better-scroll/core'
import { setStorage, getStorage } from '@/utils/localstorage.js'
import BenzAMRRecorder from 'benz-amr-recorder'
import {
    Log_Status,
    IMG_LOOP_INTERVAL,
    LOG_LOOP_INTERVAL,
    TICKET_DATABASE_NAME
} from '@/configs/constants'
import DbUtility from '@/utils/DbUtility'
export default {
    name: 'ServiceDetail',
    props: ['id'],
    data() {
        return {
            projectId: window.env.VUE_APP_TICKET_SERVICE_ID,
            detail: {},
            inputVal: '',
            loading: false,
            showBackToBotton: false,
            scroll: {},
            timer: null,
            isAStaff: false,
            status: [],
            imgLoopTimer: null,
            startQ: [],
            staffId: null,
            changeToAction: null,
            isShowCommentModal: false,
            remark: '',
            showVoiceIcon: true,
            pressed: false,
            hasRecordAccess: false,
            hasStopped: false,
            maxDuration: 30000,
            flag: {
                hasRecommedSample: false
            },
            voiceDic: {},
            recordDuration: 0,
            db: null,
            staffInfo: []
        }
    },
    components: {
        VoiceSvg,
        VoiceIconSvg
    },
    computed: {
        ...mapState(['userInfo']),
        replys() {
            const t = this.detail.logs
                ? this.detail.logs.filter(item => item.type === 'Reply')
                : []
            return t
        },
        canComment() {
            return !this.staffId && this.isEnd
        },
        // 结束待评价
        isEnd() {
            return this.status[0] && this.status[0].remark.includes('结束')
        },
        // 会话结束
        isRealEnd() {
            return this.status[0] && !this.status[0].transitions.length
        },
        endOrRealEnd() {
            return this.isEnd || this.isRealEnd
        },
        imgGroup() {
            return this.detail.logs.reduce((pre, cur) => {
                if (
                    cur.content.detail &&
                    cur.content.detail.msgType === 'image'
                ) {
                    pre.push(cur.content.content)
                }
                return pre
            }, [])
        },
        // 结束评价
        commentActions() {
            if (!this.canComment) return []
            const actions = this.actions.reduce((pre, cur) => {
                const t = cur.name.includes('满意')
                if (t) {
                    pre.push(
                        Object.assign({}, cur, {
                            remark: cur.name.split(/[（）]/)[1]
                        })
                    )
                }
                return pre
            }, [])
            return actions
        },
        actions() {
            if (!this.status[0]) return []
            const avaliableStatus = this.status[0].transitions.map(cur => {
                const t = this.status.find(item => cur.to === item.id)
                if (t) {
                    return {
                        name: t.remark,
                        id: t.id
                    }
                }
            })
            return avaliableStatus
        }
    },
    destroyed() {
        this.timer && clearTimeout(this.timer)
        this.imgLoopTimer && clearTimeout(this.imgLoopTimer)
    },
    methods: {
        ...mapActions(['isStaff', 'getRole']),
        async playVoice({ content, id }, index) {
            try {
                await this.setVoiceContent({ src: content.content, id })
                const [voiceCom] = this.$refs['voiceIcon_' + index]
                if (voiceCom) {
                    voiceCom.start()
                    await this.playVoiceContent(id)
                    voiceCom.stop()
                }
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        setVoiceContent({ src, id }) {
            return new Promise((resolve, reject) => {
                let amr = this.voiceDic[id]
                if (!/^http.+\.amr$/.test(src)) {
                    reject('不是有效的音频')
                }
                if (!amr) {
                    this.$set(this.voiceDic, id, { loading: true })
                    amr = new BenzAMRRecorder()
                    amr.initWithUrl(src).then(() => {
                        this.$set(
                            this.voiceDic,
                            id,
                            Object.assign(amr, { loading: false })
                        )
                        resolve()
                    })
                } else {
                    resolve()
                }
            })
        },
        playVoiceContent(id) {
            return new Promise((resolve, reject) => {
                let amr = this.voiceDic[id]
                if (!amr) {
                    resolve()
                    return
                }
                if (amr.isPlaying()) {
                    // 停止播放
                    amr.stop()
                } else {
                    // 重新播放
                    amr.play()
                }
                amr.onEnded(resolve)
            })
        },
        // 5分钟之内的对话不显示时间
        setTimeFormatTime(data) {
            data.forEach((item, index) => {
                item.formatTime = this.needTime(data[index], data[index - 1])
                    ? this.timeFormat(data[index].createdAt)
                    : null
            })
        },
        needTime(current, last) {
            const currentTime = current.createdAt
            const lastTime = last && last.createdAt
            if (lastTime) {
                return dayjs(currentTime)
                    .subtract(5, 'm')
                    .isAfter(lastTime)
            }
            return true
        },
        timeFormat(time) {
            return dayjs(time).format('YYYY/MM/DD HH:mm')
        },
        switchIconStatus() {
            this.showVoiceIcon = !this.showVoiceIcon
            !this.showVoiceIcon && this.authorizeRecord()
        },
        async onPress() {
            if (this.pressed) return
            if (!this.hasRecordAccess) {
                return this.$message.fail('未开启录音授权')
            }
            this.recordDuration = Date.now()
            wx.startRecord()
            this.pressed = true
            this.$refs.voiceSvg.start()
            setTimeout(this.onPressup, this.maxDuration)
        },
        async authorizeRecord() {
            try {
                if (!this.hasRecordAccess) {
                    wx.startRecord()
                    await sleep(500)
                    await this.stopRecord()
                    this.hasRecordAccess = true
                }
            } catch (error) {
                this.hasRecordAccess = false
                throw error
            }
        },
        // 停止录音
        stopRecord() {
            return new Promise(resolve => {
                wx.stopRecord({
                    success: function(res) {
                        resolve(res.localId)
                    },
                    fail(error) {
                        console.error('stopRecord:fail', error)
                    }
                })
            })
        },
        // 禁止选中文字
        touchstart(e) {
            this.onPress()
            e.preventDefault()
        },
        // 录音
        async onPressup() {
            try {
                if (!this.hasRecordAccess) {
                    return this.$message.fail('未开启录音授权')
                }
                const localId = await this.stopRecord()
                this.recordDuration = Date.now() - this.recordDuration
                this.sendVoice(localId, this.recordDuration)
            } catch (error) {
                this.$message.fail(`录音时发生错误：${error.message}`)
            } finally {
                this.recordDuration = 0
            }
        },
        // 语音聊天
        async sendVoice(localId, duration) {
            let loadingToast
            try {
                this.pressed = false
                this.$refs.voiceSvg.stop()
                loadingToast = this.$message.loading({
                    forbidClick: true,
                    duration: 0
                })
                const [translateResult, url] = await saveMedia(localId)
                if (url) {
                    const reply = {
                        content: url,
                        detail: {
                            headImg: this.userInfo.headimgurl,
                            nickname: this.userInfo.nickname,
                            localId,
                            duration,
                            translateResult,
                            msgType: 'voice'
                        }
                    }
                    this.sendMessage(reply)
                } else {
                    throw Error('语音上传失败')
                }
            } catch (error) {
                this.$message.fail(error.message)
            } finally {
                loadingToast.clear()
            }
        },
        // 满意度评论
        comment(action) {
            this.changeToAction = action
            // 改为正在对话
            if (action.remark === '否') {
                this.changeToAction.id = this.status.find(
                    item => item.remark === '正在对话'
                ).id
            }
            this.changeStatus()
            this.isShowCommentModal = false
        },
        async changeStatus() {
            try {
                const { name, id } = this.changeToAction
                await PutTransition({
                    projectId: this.projectId,
                    ticketNumber: this.id,
                    statusId: id,
                    auditorIds: null,
                    staffId: this.staffId,
                    remark: this.remark
                })
                this.setStatus()
                this.$message.success('状态变更成功')
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        imgPreview(curImg) {
            const startPosition = this.imgGroup.findIndex(img => curImg === img)
            this.$imgPreview({
                images: this.imgGroup,
                startPosition,
                loop: false
            })
        },
        uploadImgPreivew(img) {
            this.$imgPreview({ images: [img] })
        },
        async upload(file) {
            try {
                const content = await this.convertFile2Blob(file.file)
                const replyContent = {
                    content,
                    detail: {
                        headImg: this.userInfo.headimgurl,
                        nickname: this.userInfo.nickname,
                        msgType: 'image'
                    }
                }
                this.addNew({
                    content: replyContent,
                    genId: genId(),
                    type: 'Reply',
                    operator: {
                        type: this.isAStaff ? 'Staff' : 'User'
                    }
                })
                const signature = await GetUploadSignature(
                    this.projectId,
                    this.id
                )
                const { url } = await Upload(signature, file.file)
                replyContent.detail.url = url
                await this.send(
                    Object.assign({}, replyContent, {
                        content: url
                    })
                )
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        convertFile2Blob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsArrayBuffer(file)
                reader.onload = function(event) {
                    // blob
                    const blob = new Blob([event.target.result])
                    window.URL = window.URL || window.webkitURL
                    const blobURL = window.URL.createObjectURL(blob)
                    resolve(blobURL)
                }
            })
        },
        addNew(content, loading = true) {
            const { logs } = this.detail
            if (Array.isArray(content)) {
                const t = content.map(item => ({ loading, ...item }))
                logs.push(...t)
            } else {
                logs.push({ loading, ...content })
            }
            this.scrollToBottom()
        },
        preBindId(content) {
            let res = []
            if (!Array.isArray(content)) {
                content = [content]
            }
            for (let item of content) {
                if (item.content.detail && item.type === 'Reply') {
                    const t = this.detail.logs.find(log => {
                        if (log.type === 'Reply' && log.content) {
                            const { detail, content } = log.content
                            if (log.id) {
                                return log.id === item.id
                            } else {
                                return (
                                    (detail.url || content) ===
                                    item.content.content
                                )
                            }
                        }
                    })
                    if (t) {
                        t.id = item.id
                        t.loading = false
                        continue
                    }
                }
                res.push(item)
            }
            return res
        },
        findLast(arr, fn) {
            let i = arr.length - 1
            while (i >= 0) {
                if (fn(arr[i])) {
                    return arr[i]
                } else {
                    i--
                }
            }
        },
        refreshStatus(data) {
            if (data.some(item => item.type === 'StatusChange')) {
                this.setStatus()
            }
        },
        async addLocalLogs(logs) {
            this.db.addAll(logs)
        },
        async getLogFromLocal() {
            this.db = await new DbUtility(TICKET_DATABASE_NAME, 2).open({
                deleteWhenUpgradeneed: ['logs']
            })
            const index = { name: 'ticketNumber', unique: false }
            return await this.db
                .createStore('logs', { keyPath: 'id', index: [index] })
                .then(db =>
                    db.get({ index: index.name, key: this.id, multi: true })
                )
        },
        async loadData(scrollToBottom) {
            let loadingToast
            try {
                const { logs } = this.detail
                if (logs) {
                    const { id: nextLog } =
                        this.findLast(logs, item => item.id) || {}
                    const data = await GetNewLogs({
                        projectId: this.projectId,
                        ticketNumber: this.id,
                        nextLog,
                        staffId: this.staffId,
                        logTypes: ['Reply', 'StatusChange']
                    })
                    if (data.length) {
                        // this.addLocalLogs(data)
                        this.refreshStatus(data)
                        const msgList = this.preBindId(data)
                        this.addNew(msgList, false)
                    }
                } else {
                    loadingToast = this.$message.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    })
                    this.setStatus()
                    const detail = await GetTicketDetail({
                        projectId: this.projectId,
                        ticketNumber: this.id,
                        withLogs: true,
                        logTypes: ['Reply']
                    })
                    this.checkTicketBelonging(detail.ticket)
                    this.setTimeFormatTime(detail.logs)
                    this.detail = detail
                    this.startQ = this.detail.ticket.parameters
                    scrollToBottom && this.scrollToBottom(0)
                }
                this.setLocalLogStaus()
            } catch (error) {
                this.$errorHandler(error)
                throw error
            } finally {
                loadingToast && loadingToast.clear()
            }
        },
        checkTicketBelonging({ status } = {}) {
            if (!this.staffId) return
            const { auditors } = status || {}
            if (Array.isArray(auditors) && !auditors.includes(this.staffId)) {
                this.$router.replace({ name: 'customerService' })
            }
        },
        setLocalLogStaus() {
            const {
                logs,
                ticket: { ticketNumber }
            } = this.detail
            const { id: nextLog } = this.findLast(logs, item => item.id) || {}
            const logStatus = getStorage(Log_Status) || {}
            if (
                !(
                    logStatus[ticketNumber] &&
                    logStatus[ticketNumber] === nextLog
                )
            ) {
                const t = Object.assign(logStatus, { [ticketNumber]: nextLog })
                setStorage(Log_Status, t)
            }
        },
        showUserComment() {
            this.isShowCommentModal = true
        },
        imgLoadQueue() {
            const imgs = Array.from(
                document.querySelectorAll('.message-list-item .text img')
            )
            return new Promise((resolve, reject) => {
                this.imgLoopTimer = setTimeout(() => {
                    if (imgs.every(img => img.complete)) {
                        resolve()
                    } else {
                        this.imgLoadQueue()
                    }
                }, IMG_LOOP_INTERVAL)
            })
        },
        poll() {
            this.timer = setTimeout(async () => {
                await this.loadData()
                await this.$nextTick()
                this.scroll.refresh()
                this.poll()
            }, LOG_LOOP_INTERVAL)
        },
        async initView() {
            await this.loadData(true)
            this.poll()
            this.scroll = new BScroll(this.$refs.wrapper, {
                pullDownRefresh: {
                    threshold: 50,
                    stop: 20
                },
                click: true,
                preventDefaultException: { className: /(^|\s)say(\s|$)/ },
                probeType: 3
            })
            // 回到最新位置
            this.scroll.on('scroll', ({ y }) => {
                if (y > this.scroll.maxScrollY) {
                    this.showBackToBotton = true
                } else {
                    this.showBackToBotton = false
                }
            })
            this.scroll.on('scrollStart', () => {
                this.showBackToBotton = false
            })
        },
        async setRole() {
            const { staffId } = await this.getRole(this.projectId)
            if (staffId) {
                this.staffId = staffId
            }
        },
        scrollToBottom(time = 500) {
            this.$nextTick(async () => {
                await this.imgLoadQueue()
                this.scroll.refresh()
                this.scroll.scrollTo(0, this.scroll.maxScrollY, time)
            })
        },
        onBlur() {
            this.scroll.refresh()
        },
        onFocus() {
            this.scrollToBottom(0)
        },
        async send(replyContent) {
            await Reply({
                projectId: this.projectId,
                ticketNumber: this.id,
                ...replyContent,
                staffId: this.staffId
            })
        },
        async sendMessage(
            replyContent = {
                content: this.inputVal,
                detail: {
                    headImg: this.userInfo.headimgurl,
                    nickname: this.userInfo.nickname,
                    msgType: 'text'
                }
            }
        ) {
            try {
                if (!replyContent.content || this.isRealEnd) return
                this.addNew({
                    content: replyContent,
                    genId: genId(),
                    type: 'Reply',
                    operator: {
                        type: this.isAStaff ? 'Staff' : 'User'
                    }
                })
                await this.send(replyContent)
                this.inputVal = ''
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        setStatus() {
            this.isStaff(this.projectId).then(res => (this.isAStaff = res))
            GetAvailableStatus(this.projectId, this.id).then(({ statuses }) => {
                this.status = statuses
            })
        },
        addAutoNew(content) {
            const hasHeadImgLog = this.detail.logs.find(
                _ => _.content.detail && _.content.detail.headImg
            )
            if (hasHeadImgLog) {
                const {
                    content: {
                        detail: { headImg }
                    }
                } = hasHeadImgLog
                this.addNew({
                    content: {
                        content,
                        detail: {
                            headImg
                        }
                    },
                    genId: genId(),
                    type: 'Reply',
                    operator: {
                        type: 'Staff'
                    }
                })
            }
        },
        getStaffName(message) {
            const { staffId } = message.operator
            if (staffId) {
                let staff
                if (
                    this.staffInfo[0] &&
                    (staff = this.staffInfo[0].find(t => t.id === staffId))
                ) {
                    return 'ifm客服 ' + staff.name
                }
                if (
                    this.staffInfo[1] &&
                    (staff = this.staffInfo[1].find(t => t.id === staffId))
                ) {
                    return '技术专家 ' + staff.name
                }
            }
            return message.content.detail.nickname
        },
        async bindStaffDic() {
            const { staffs: customStaff } = await GetAvailableAuditor(
                this.projectId,
                '客服'
            )
            const { staffs: exportStaff } = await GetAvailableAuditor(
                this.projectId,
                '专家'
            )
            this.staffInfo.push(customStaff, exportStaff)
        }
    },
    async mounted() {
        this.bindStaffDic()
        await this.setRole()
        this.initView()
    },
    watch: {
        canComment(v) {
            v && this.showUserComment()
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin';
@borderRadius: 0.25rem;
@chatHeight: 2.4rem;
@bar-height: 2rem;
@box-content-height: 1.1rem;
.message-list-wrapper {
    flex: 1;
    background: #f5f5f5;
    overflow: hidden;
    /deep/.van-cell__value {
        flex: 2;
    }
}
.chat-container {
    background: green;
    height: 100%;
    // padding-top: @bar-height;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.back-to-bottom {
    display: flex;
    align-items: center;
    &::before {
        content: '';
        .arrow(bottom, 5px, @themeColor);
        margin-right: 8px;
    }
    position: fixed;
    right: 10px;
    bottom: 12vh;
    border: 1px solid #f5f5f5;
    padding: 5px 10px;
    color: @themeColor;
    border-radius: 50px;
    background: #fff;
}
.message-list {
    overflow-y: auto;
    padding: 0.6rem;
    .question-desc-box {
        margin-bottom: @padding-md;
    }
    .upload-img {
        max-width: 100%;
        max-height: 30vh;
        object-fit: contain;
    }
    .chat-time {
        text-align: center;
        margin: @padding-md 0;
        color: @gray-6;
    }
    &-item {
        margin-bottom: 20px;
        display: flex;
        align-items: flex-start;
        .head {
            display: block;
            width: 1.9rem;
            object-fit: contain;
            border-radius: 5px;
            margin-top: 0.5rem;
        }
        .default-head {
            font-size: 1.9rem;
        }
    }
    .right {
        flex-direction: row-reverse;
        .text-box {
            color: #fff;
            .content-box {
                margin-left: 0;
                margin-right: 0.6rem;
                align-items: flex-end;
            }
            .text {
                background: @themeColor;

                .tri(right, @themeColor);
            }
            .svg {
                transform: rotate(180deg);
            }
            .voice {
                flex-direction: row-reverse;
                .duration {
                    margin-right: @padding-md;
                    margin-left: 0;
                }
            }
        }
    }
    .voice {
        display: flex;
        min-height: @box-content-height;
        align-items: center;
        .icon-wrapper {
            display: flex;
            align-items: center;
        }
        .duration {
            margin-left: @padding-md;
        }
    }
}
.disabled {
    opacity: 0.5;
    pointer-events: none;
}
.chat-input {
    position: relative;
    z-index: 999;
    height: @chatHeight;
    background: #ededed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0.6rem;
    .end-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        flex: 1;
        margin: 0 0.4rem;
        border-radius: @borderRadius;
        background: #c4c4c4;
    }
    .photo-wrapper {
        width: 1.9rem;
        height: 1.6rem;
        margin-right: 0.4rem;
    }
    .photo {
        width: 1.9rem;
        height: 1.6rem;
        border-radius: @borderRadius;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333333;
        font-size: 1.2rem;
        background: #dfdfdf;
    }
    &-box,
    &-press-bar {
        flex: 1;
        margin: 0 0.4rem;
        height: 100%;
    }
    &-box {
        padding: 6px 10px;
        margin: 0 0.6rem;
    }
    &-press-bar {
        display: flex;
        justify-content: center;
        border-radius: @borderRadius;
        align-items: center;
        background: #fff;
    }
    .pressed {
        background: #d4d4d4;
    }
    .icon-box {
        width: 1.9rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #dfdfdf;
        border-radius: @borderRadius;
        .icon {
            width: 1rem;
            object-fit: contain;
        }
    }
    .send-button {
        height: 100%;
        color: #000;
        background: #dfdfdf;
        border-radius: @borderRadius;
        width: 2rem;
        height: 1.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.text-box {
    display: flex;
    align-items: center;
    max-width: 70%;
    font-size: 0.65rem;
    line-height: @box-content-height;
    color: @themeColor;
    .content-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: @spacing;
        .name {
            max-width: 8rem;
            color: @text-color;
            .ellipsis();
        }
    }
    .loading-icon {
        font-size: 12px;
        margin-right: @padding-xs;
        align-self: flex-end;
    }
    .text {
        word-break: break-all;
        background: #fff;
        padding: 0.4rem 0.75rem;
        border-radius: 4px;
        position: relative;
        .tri(left, #fff);
        > img {
            width: 100%;
            max-height: 30vh;
            object-fit: contain;
        }
    }
}
.comment-modal {
    width: 70%;
    padding: 0.8rem 1.2rem;
    background: #fff;
    .question {
        margin-bottom: 1.5rem;
    }
    .button-group {
        display: flex;
        justify-content: center;
        .button {
            width: 40%;
            text-align: center;
            background: #f3f3f3;
            padding: 0.4rem 0;
            border-radius: 0.8rem;
            &:not(:last-child) {
                margin-right: 10%;
            }
        }
    }
}
</style>
